import { render } from "./TermsAndConditionsView.vue?vue&type=template&id=a5380d68&scoped=true"
const script = {}

import "./TermsAndConditionsView.vue?vue&type=style&index=0&id=a5380d68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5380d68"]])

export default __exports__